import { Component, OnInit, Output, EventEmitter, Input, Injectable, OnDestroy } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateStruct, NgbModal, NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MeetingService } from 'src/app/core/service/meeting.service';
import { ToastAlertService } from 'src/app/shared/utils/toast.service';
import { IMeetingAvailability, IMeetingPatchModel, METTING_AVAILABILITY, MeetingTime } from 'src/app/core/domain/meetings.model';
import * as moment from 'moment-timezone';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Observable, Subject, takeUntil, tap } from 'rxjs';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { getProfileData } from 'src/app/core/state/profile';
import { ProfileService } from 'src/app/core/service/profile.service';
import { add } from 'date-fns';
import { calculateSlots, convertToLocalTime, createTimeSlots, findNextAvailableDate, generateTimeSlots, generateTimeSlotsWithAMPM, isDisabledDateForMeeting } from 'src/app/shared/utils/common-methods';
import { MilestonesService } from 'src/app/core/service/milestone.service';
import { accountTypelabelMap } from 'src/CONSTS';

import { getBrandDetails } from 'src/app/core/state/global';
import { IBrandDetails } from 'src/app/core/domain/brand.model';
import { NgbTimeStringAdapter } from '../add-meeting-button/add-meeting-modal/add-meeting-modal.component';
import { FacilitiesService } from 'src/app/core/service/facilities.service';
import { FacilityAddon, IBookingByFaciilityUUID, IFacility,IBookedCapacity } from 'src/app/core/domain/facility.model';
import { ACCOUNT_TYPE, OrganizationInformationResponseModel } from 'src/app/core/domain';
import { getCorporateInfo } from 'src/app/core/state/corporate-info';
import { getIndividualProfileInfo } from 'src/app/core/state/individual-profile-info';
import { getInvestorsOrg } from 'src/app/core/state/investors-organization-info';
import { getMentorInfo } from 'src/app/core/state/mentor-info';
import { getPartnerInfo } from 'src/app/core/state/partner-info';
import { getProgramOfficeInfo } from 'src/app/core/state/program-office-members-info';
import { getServiceProviderInfo } from 'src/app/core/state/service-provider-info';
import { getStartUpInfo } from 'src/app/core/state/startup';
import * as InvestorsOrgInfoActionActions from "src/app/core/state/investors-organization-info/investors-organization-info.action";
import * as StartupActions from "src/app/core/state/startup/startup.action";
import * as CorporateActions from "src/app/core/state/corporate-info/corporate-info.action";
import * as MentorActions from "src/app/core/state/mentor-info/mentor-info.action";
import * as ServiceProviderActions from "src/app/core/state/service-provider-info/service-provider-info.action";
import * as PartnerActions from "src/app/core/state/partner-info/partner-info.action";
import * as ProgramOfficeActions from "src/app/core/state/program-office-members-info/program-office-members-info.action";
import * as IndividualActions from "src/app/core/state/individual-profile-info/individual-profile-info.action";
import * as ProfileActions from "src/app/core/state/profile/profile.action";
import { PaymentsService } from 'src/app/core/service/payments.service';
import { ModalHandlerService } from 'src/app/core/service/modal-handler.service';
import { th } from 'date-fns/locale';
import { Router } from '@angular/router';
import { end } from '@popperjs/core';

const pad = (i: number): string => i < 10 ? `0${i}` : `${i}`;

@Component({
 selector: 'app-book-facilitys',
  templateUrl: './book-facilitys.component.html',
  styleUrls: ['./book-facilitys.component.scss'],
  providers: [
    { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },
  ]
})
export class BookFacilitysComponent implements OnInit, OnDestroy {
 isModalOpen = false;
  model: NgbDateStruct;
  endDateModel: NgbDateStruct
  routeStateDate: string | null = null;
  routeStateEndDate: string | null = null;

  time = { hour: 13, minute: 30 };

  meetingForm: FormGroup;
  @Input() facility: IFacility
  @Input() isPublicRoute: boolean
  @Input() isAvailablityfacility: {price: number, unit: string}
  @Input() isAvailableSeats: number;
  @Output() bookedCapacityChange = new EventEmitter<IBookedCapacity>()
  bookedCapacity:IBookedCapacity
  @Input() modalData: {
    otherUser: {
      userUUID?: string;
      uid?: string;
      name: string;
    };
  };
  minDate;
  public getProfileData$: Observable<IProfileDetails>;
  profileData: IProfileDetails;
  private destroyed$: Subject<void> = new Subject();
  // accountTypelabelMap = accountTypelabelMap
  // companyName = '';

  // userProfileData;
  calenderAvilablity: IMeetingAvailability;
  disabledDaysIndex = []
  timeSlots: Array<{
    label: string,
    value: string
  }> = []
  endTimeSlots: Array<{
    label: string,
    value: string
  }> = []
  METTING_AVAILABILITY = METTING_AVAILABILITY;
  // reviewers = [];
  // selectedMeetingWithUser;
  brandDetails: Partial<IBrandDetails>;
  facilityBookedForDay;
  facilityBookedForDayCalculatedOnFrontend;
  allBookingsOfFacility: IBookingByFaciilityUUID[] = []
  constructor(
    private meetingService: MeetingService,
    private toastAlertService: ToastAlertService,
    private modal: NgbModal,
    private ngxLoaderService: NgxUiLoaderService,
    private store: Store,
    private profileService: ProfileService,
    private calendar: NgbCalendar,
    private facilitiesService: FacilitiesService,
    private paymentsService: PaymentsService,
    private modalHandler: ModalHandlerService,
     private router: Router,
      private facilityService: FacilitiesService,
  ) { }

  ngOnInit(): void {
    this.routeStateDate = history?.state?.date || null;
    this.routeStateEndDate = history?.state?.endDate || null;
     this.facility.facilityAddons.forEach(addon => {
    addon.selected = false;
    addon.selectedQuantity = 0; 
  });
    this.getProfileData$ = this.store.pipe(select(getProfileData));

    this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.brandDetails = res;



        this.getProfileData$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(async (res) => {
          if (res) {
            if(!res.email) {
              this.store.dispatch(new ProfileActions.GetProfile());
            }
            this.profileData = res;
            if(this.profileData &&this.profileData.email) {
              await this.getMeetingAvailability(this.facility.uuid)
              this.getMeetingCompanyName();

            }
        }else{
           await this.getMeetingAvailability(this.facility.uuid)
           this.setMeetingForm();
        }})

      }
    })

    this.facilitiesService.getAllBookingsOfFacilityId(this.facility.uuid).subscribe((res)=> {
      console.log('availablit', res)
      if(res) {
        this.allBookingsOfFacility = res;
      }
    })
  }

  existingBookedPayment
  holdRemainingSeconds = 0;
  showErrorForFreeBookedFacility=false;
  holdRemainingTimeText = '';
  private holdTimerRef: any;

  private formatHoldTime(totalSeconds: number): string {
    const safeSeconds = Math.max(0, Number(totalSeconds) || 0);
    const minutes = Math.floor(safeSeconds / 60);
    const seconds = safeSeconds % 60;
    return `${pad(minutes)}:${pad(seconds)}`;
  }

  private stopHoldCountdown(): void {
    if (this.holdTimerRef) {
      clearInterval(this.holdTimerRef);
      this.holdTimerRef = null;
    }
  }

  private startHoldCountdown(totalSeconds: number): void {
    this.stopHoldCountdown();
    this.holdRemainingSeconds = Math.max(0, Number(totalSeconds) || 0);
    this.holdRemainingTimeText = this.formatHoldTime(this.holdRemainingSeconds);

    if (this.holdRemainingSeconds <= 0) {
      return;
    }

    this.holdTimerRef = setInterval(() => {
      this.holdRemainingSeconds = Math.max(0, this.holdRemainingSeconds - 1);
      this.holdRemainingTimeText = this.formatHoldTime(this.holdRemainingSeconds);
      if (this.holdRemainingSeconds <= 0) {
        this.stopHoldCountdown();
      }
    }, 1000);
  }

  get holdRemainingMessage(): string {
    if (!this.existingBookedPayment?.data?.found || !this.holdRemainingTimeText || this.holdRemainingTimeText=='00:00') {
      return '';
    }
    return `Payment pending for this booking. Remaining time to pay: ${this.holdRemainingTimeText}`;
  }

   getExistingBookedFacilitie(facility: IFacility) {
     let token = localStorage.getItem('booking_session_token');
    const values = this.meetingForm.value
    const selectedDate = values?.date;
    const formattedStartDate = selectedDate
      ? moment(`${selectedDate.year}-${selectedDate.month}-${selectedDate.day}`, 'YYYY-M-D').format('YYYY-MM-DD')
      : null;

    const postData = {
      facilityId: facility.id,
      startDate: formattedStartDate,
      sessionToken: token,
       userId: this.profileData?.id ||null
    }
     this.facilityService.getExistingBooking(postData).subscribe((res) => {
       this.existingBookedPayment=res;
  
      if (res.data?.found) {
        if(res?.data?.holdRemainingSeconds==null && res?.data.booking.orderNumber){ 
          this.showErrorForFreeBookedFacility=true;
        
        const remainingSeconds = res?.data?.holdRemainingSeconds ?? res?.holdRemainingSeconds ?? 0;
        this.startHoldCountdown(remainingSeconds);
        this.meetingForm.patchValue({
          bookingDuration: res.data.booking.bookingTimeType,
          numberOfDays: res.data.booking.duration,
          numberOfSeats: res.data.booking.bookedCapacity,
        });
        this.setDuration(this.existingBookedPayment.data.booking.bookingTimeType);
      }else if(res?.data?.holdRemainingSeconds!=null){
   const remainingSeconds = res?.data?.holdRemainingSeconds ?? res?.holdRemainingSeconds ?? 0;
        this.startHoldCountdown(remainingSeconds);
        this.meetingForm.patchValue({
          bookingDuration: res.data.booking.bookingTimeType,
          numberOfDays: res.data.booking.duration,
          numberOfSeats: res.data.booking.bookedCapacity,
        });
        this.setDuration(this.existingBookedPayment.data.booking.bookingTimeType);
      }
      } else {
        this.stopHoldCountdown();
        this.holdRemainingSeconds = 0;
         this.showErrorForFreeBookedFacility=false;
        this.holdRemainingTimeText = '';
        this.meetingForm.patchValue({
          bookingDuration: this.isAvailablityfacility?.unit,
          basePrice:this.isAvailablityfacility?.price ,
          numberOfDays: 1,
          numberOfSeats: 1,
          meetingDescription: ''
        }, { emitEvent: false });
       this.setDuration(this.isAvailablityfacility?.unit);
        this.calculateTotal();
         this.updateEndDateForPaymentRequired();
      }
    })
  }

increase(addon: FacilityAddon) {
  if (addon.selectedQuantity < addon.quantity) {
    addon.selectedQuantity++;
    this.calculateTotal();
  }
}

decrease(addon: FacilityAddon) {
  if (addon.selectedQuantity > 0) {
    addon.selectedQuantity--;
    this.calculateTotal();
  }
}

isSelected(addon: FacilityAddon): boolean {
  return addon.selectedQuantity > 0;
}
checkFacilityBookedForDay(
  startDateParam?: NgbDateStruct,
  endDateParam?: NgbDateStruct
) {
  if (!startDateParam || !endDateParam) {
    this.facilityBookedForDayCalculatedOnFrontend = false;
    return;
  }

  if (!this.isDayBasedType() || !this.facility.bookingAvailableFrom) {
    this.facilityBookedForDayCalculatedOnFrontend = false;
    return;
  }

  const booking = this.facility.bookingAvailableFrom;

  if (booking.bookingTimeType !== 'day') {
    this.facilityBookedForDayCalculatedOnFrontend = false;
    return;
  }

  const selectedStart = moment(
    `${startDateParam.year}-${startDateParam.month}-${startDateParam.day}`,
    'YYYY-MM-DD'
  );

  const selectedEnd = moment(
    `${endDateParam.year}-${endDateParam.month}-${endDateParam.day}`,
    'YYYY-MM-DD'
  );

  const bookingStart = moment(booking.startDate, 'YYYY-MM-DD');
  const bookingEnd = moment(booking.endDate, 'YYYY-MM-DD');

  const isBooked =
    selectedStart.isBetween(bookingStart, bookingEnd, 'day', '[]') ||
    selectedEnd.isBetween(bookingStart, bookingEnd, 'day', '[]') ||
    (selectedStart.isSameOrBefore(bookingStart) &&
     selectedEnd.isSameOrAfter(bookingEnd));

  this.facilityBookedForDayCalculatedOnFrontend = isBooked;
}



  facilityBookedForHour = false;
 checkFacilityBookedForHour(startSlot?: string, endSlot?: string) {

  if (!this.facility.bookingAvailableFrom) {
    this.facilityBookedForHour = false;
    return;
  }

  const booking = this.facility.bookingAvailableFrom;

  if (booking.bookingTimeType !== 'hour') {
    this.facilityBookedForHour = false;
    return;
  }

  const formValues = this.meetingForm.value;

  const startTime = startSlot ?? formValues.timeFrom;
  const endTime = endSlot ?? formValues.timeTo;

  if (!startTime || !endTime) {
    this.facilityBookedForHour = false;
    return;
  }

  const selectedStart = moment(startTime, 'HH:mm');
  const selectedEnd = moment(endTime, 'HH:mm');

  const bookingStart = moment(booking.startTime, 'HH:mm:ss');
  const bookingEnd = moment(booking.endTime, 'HH:mm:ss');

  const isBooked =
    selectedStart.isBetween(bookingStart, bookingEnd, null, '()') ||
    selectedEnd.isBetween(bookingStart, bookingEnd, null, '()') ||
    (selectedStart.isSameOrBefore(bookingStart) &&
     selectedEnd.isSameOrAfter(bookingEnd));

  this.facilityBookedForHour = isBooked;
}



// isDisabled = (date: NgbDate) => {

//   // Disable TODAY for day/week/month/year imp.
//   if (this.isDayBasedType()) {
//     const today = this.calendar.getToday();
//   if (
//     this.isDayBasedType() &&
//     date.year === today.year &&
//     date.month === today.month &&
//     date.day === today.day
//   ) {
//     return true;
//   }
//   }

//   if (this.isDayBasedType() && this.allBookingsOfFacility?.length) {
//     const dateToCheck = moment(
//       `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`,
//       'YYYY-MM-DD'
//     );

//     const booked = this.allBookingsOfFacility.find(e => {
//       const start = moment(e.startDate, 'YYYY-MM-DD');
//       const end = moment(e.endDate, 'YYYY-MM-DD');
//       return dateToCheck.isBetween(start, end, 'date', '[]');
//     });

//     if (booked) return true;
//   }

//   return isDisabledDateForMeeting(
//     date,
//     this.calenderAvilablity,
//     this.calendar,
//     this.disabledDaysIndex
//   );
// };

isDisabled = (date: NgbDate) => {

  const today = this.calendar.getToday();

  // Always disable TODAY
  if (
    date.year === today.year &&
    date.month === today.month &&
    date.day === today.day
  ) {
    return true;
  }

    const availabilityDisabled = isDisabledDateForMeeting(
    date,
    this.calenderAvilablity,
    this.calendar,
    this.disabledDaysIndex
  );

  if (availabilityDisabled) return true;

  //  I seats available → don't disable 
  if ((this.isAvailableSeats ?? 0) > 0) {
    return false;
  }

  // If day based booking and already booked → disable
  if (this.isDayBasedType() && this.facility.bookingAvailableFrom) {

  const booking = this.facility.bookingAvailableFrom;

  if (booking.bookingTimeType === 'day') {

    const dateToCheck = moment(
      `${date.year}-${date.month}-${date.day}`,
      'YYYY-MM-DD'
    );

    const start = moment(booking.startDate, 'YYYY-MM-DD');
    const end = moment(booking.endDate, 'YYYY-MM-DD');

    if (dateToCheck.isBetween(start, end, 'day', '[]')) {
      return true;
    }
  }
}


  return isDisabledDateForMeeting(
    date,
    this.calenderAvilablity,
    this.calendar,
    this.disabledDaysIndex
  );
};




  async getMeetingAvailability(uid: string) {
    const res = await this.facilitiesService.getUsersAvailabilityById(uid).toPromise()
    console.log('ress-----', res)
    // subscribe((res)=>{
    this.calenderAvilablity = res.data || {};
    // console.log('this.calenderAvilablity',this.calenderAvilablity)
    if (this.calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.specific_days) {
      this.disabledDaysIndex = (this.calenderAvilablity.days||[]).filter((e) => e.closed).map(e => e.dayIndex)
      console.log('this.disabledDaysIndex', this.disabledDaysIndex)
    } else if (this.calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.anytime) {
      this.timeSlots = generateTimeSlotsWithAMPM(this.calenderAvilablity.hourlySlotTime || this.brandDetails?.features?.meeting_time_slot_difference_in_mins);
    }
    // })
  }


  getCompanyDetails() {
    const uid = this.modalData.otherUser.uid || this.modalData.otherUser.userUUID
    this.profileService.getUserPublicProfile(uid).subscribe(async (res) => {
      if (res) {
        await this.getMeetingAvailability(uid)
      }
    }, (error) => {
    })

  }

private isDayBasedType(): boolean {
  return ['day', 'week', 'month', 'year'].includes(
    this.calenderAvilablity?.availabilityTimeType
  );
}

private toDateStruct(date: string): NgbDateStruct | null {
  if (!date) {
    return null;
  }
  const parsed = moment(date, ['YYYY-MM-DD', moment.ISO_8601], true);
  if (!parsed.isValid()) {
    return null;
  }
  return {
    year: parsed.year(),
    month: parsed.month() + 1,
    day: parsed.date()
  };
}

private applyDateStateToForm(): void {
  if (!this.meetingForm) {
    return;
  }

  const startStruct = this.toDateStruct(this.routeStateDate);
  const endStruct = this.toDateStruct(this.routeStateEndDate);

  if (!startStruct && !endStruct) {
    return;
  }

  const patchObj: any = {};
  if (startStruct) {
    patchObj.date = startStruct;
    this.model = startStruct;
  }
  if (endStruct) {
    patchObj.endDate = endStruct;
    this.endDateModel = endStruct;
  }

  this.meetingForm.patchValue(patchObj, { emitEvent: true });
  if (startStruct && endStruct) {
    this.checkFacilityBookedForDay(startStruct, endStruct);
  }
}

  setMeetingForm() {
 const leapDays =
  this.calenderAvilablity.availabilityTimeType === 'hour' ? 0 : this.calenderAvilablity.leapTime;
console.log('leapDays', leapDays)
let current = new Date();

// Day/week/month/year → start from tomorrow
if (this.isDayBasedType()) {
  current = moment().add(1, 'day').toDate();
}

   if (leapDays) {
      current = moment().add(leapDays, 'days').toDate();
    }

    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

    this.meetingForm = new FormGroup({
      date: new FormControl('', [Validators.required]),
      endDate: new FormControl('', this.calenderAvilablity.availabilityTimeType === 'hour' ? [] : [Validators.required]),
      timeFrom: new FormControl(null, this.calenderAvilablity.availabilityTimeType === 'hour' ? [Validators.required] : []),
      timeTo: new FormControl(null, this.calenderAvilablity.availabilityTimeType === 'hour' ? [Validators.required] : []),
      meetingDescription: new FormControl('', []),
      bookingPocName: new FormControl(this.profileData?.name, []),
      bookingPocEmail: new FormControl(this.profileData?.email, []),
      bookingPocContactNumber: new FormControl(this.profileData?.mobileNumber, []),
      bookingPoCOrgName: new FormControl(this.companyName, []),
      bookingPoCDesignation: new FormControl(this.profileData?.accountRole, []),
      bookingDuration: new FormControl(this.isAvailablityfacility.unit, []),
      numberOfDays: new FormControl(1, [Validators.required, Validators.min(1)]),
      numberOfSeats: new FormControl(1, [Validators.required, Validators.min(1)]),
      basePrice: new FormControl(this.isAvailablityfacility?.price ?? 0),
      totalPrice: new FormControl({ value: 0, disabled: true }),
      showSpecialRequest: new FormControl(false) 
    });
    this.calculateTotal();
   this.setDuration(this.isAvailablityfacility.unit)

  // If payment required → endDate readonly & auto calculated
  this.meetingForm.get('endDate')?.disable({ emitEvent: false });
  this.updateEndDateForPaymentRequired();

   this.meetingForm.get('date').valueChanges
  .pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
  .subscribe(async (date) => {
    this.meetingForm.get('timeTo').reset();
    this.meetingForm.get('timeFrom').reset();
    this.updateEndDateForPaymentRequired();

    if (
      this.calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.specific_days ||
      this.calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.anytime
    ) {
      this.timeSlots = await this.calculateSlots(date);
      this.checkFacilityBookedForDay(date);
    }
  });

  this.meetingForm.get('numberOfDays').valueChanges
  .pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
  .subscribe(() => {
      this.updateEndDateForPaymentRequired();
  });

    this.meetingForm.get('endDate').valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
      .subscribe((date) => {
        this.meetingForm.get('timeTo').reset()
        this.meetingForm.get('timeFrom').reset()
        if (this.calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.specific_days || this.calenderAvilablity.availabilitySettings === METTING_AVAILABILITY.anytime) {
          /* SC-SAAS-FRONTEND-V -- the start date is read from the form control; the template no longer
             mixes [(ngModel)] with formControlName, so this.model is no longer updated by user picks. */
          this.checkFacilityBookedForDay(this.meetingForm.get('date')?.value, date)
        }
      })

    this.meetingForm.get('timeFrom').valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
      .subscribe(async (change) => {
        const values = this.meetingForm.value
        const endAllTimeSlots = await this.calculateSlots(values.date, true)
        const index = endAllTimeSlots.findIndex((t) => {
          return t.value === change
        })
        this.endTimeSlots = endAllTimeSlots.slice(index+1)
        // remove slots with < time
        this.endTimeSlots = this.endTimeSlots.filter(slot => moment(slot.value, "HH:mm").isAfter(moment(change, "HH:mm")));
        this.checkFacilityBookedForHour(change)

      })
    this.meetingForm.get('timeTo').valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroyed$))
      .subscribe((change) => {
        this.checkFacilityBookedForHour(null, change)

      })
    const today = add(new Date(), {
      hours: 1,
    });
    today.setMinutes(0);
    const startTime = today.toLocaleTimeString('en-US', { hour12: false }).substring(0, 5);

    today.setHours(today.getHours() + 2)
    const endTime = today.toLocaleTimeString('en-US', { hour12: false }).substring(0, 5);


   const nextAvailableDate = findNextAvailableDate(
  this.calenderAvilablity,
  this.calendar,
  this.disabledDaysIndex,
  current
);

if (nextAvailableDate) {
  // Sync calendar model
  this.model = nextAvailableDate;

  // PATCH start date into form (CRITICAL)
  this.meetingForm.patchValue(
    { date: nextAvailableDate },
    { emitEvent: true } // allow downstream logic
  );

  //  For day/week/month/year → auto-calc end date
  if (this.isDayBasedType()) {
    this.updateEndDateForPaymentRequired();
  }
}

    this.applyDateStateToForm();

  }


  companyName = ''
  getMeetingCompanyName() {
    console.log('getMeetingCompanyNamegetMeetingCompanyName', this.profileData)
    if (this.profileData.accountType === ACCOUNT_TYPE.INVESTOR) {

      this.store.pipe(select(getInvestorsOrg)).subscribe((response: OrganizationInformationResponseModel) => {
        if (response) {
          this.companyName = response.data.organizationName
          this.setMeetingForm()
        }else{
          this.store.dispatch(new InvestorsOrgInfoActionActions.GetInvestorsOrgInfo);
        }
      });

    } else if (this.profileData.accountType === ACCOUNT_TYPE.STARTUP) {

      const startupInfo$ = this.store.pipe(select(getStartUpInfo));
      console.log('startupInfo$')
      startupInfo$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
        if (res) {
          this.companyName = res.companyName
          console.log('startupInfo comp', this.companyName)
          this.setMeetingForm()
        }else{
          this.store.dispatch(new StartupActions.GetStartUpInfo);
        }
      });
    } else if (this.profileData.accountType === ACCOUNT_TYPE.CORPORATE) {
      this.store.pipe(select(getCorporateInfo)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
        if (res) {
          this.companyName = res.data.companyName
          this.setMeetingForm()
        }else{
          this.store.dispatch(new CorporateActions.GetCorporateInfo);
        }
      });

    } else if (this.profileData.accountType === ACCOUNT_TYPE.MENTOR) {
      this.store.pipe(select(getMentorInfo)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
        if (res) {
          this.companyName = res.data.name
          this.setMeetingForm()
        }else{
          this.store.dispatch(new MentorActions.GetMentorInfo);
        }
      });

    } else if (this.profileData.accountType === ACCOUNT_TYPE.SERVICE_PROVIDER) {
      this.store.pipe(select(getServiceProviderInfo)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
        if (res) {
          this.companyName = res.data.name
          this.setMeetingForm()
        }else{
          this.store.dispatch(new ServiceProviderActions.GetServiceProviderInfo);
        }
      });

    } else if (this.profileData.accountType === ACCOUNT_TYPE.PARTNER) {

      this.store.pipe(select(getPartnerInfo)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((response) => {
        if (response) {
          this.companyName = response.data.name
          this.setMeetingForm()
        }else{
          this.store.dispatch(new PartnerActions.GetPartnerInfo);
        }
      })
    }
    else if (this.profileData.accountType === ACCOUNT_TYPE.PROGRAM_OFFICE) {

      this.store.pipe(select(getProgramOfficeInfo)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((response) => {
        if (response) {
          this.companyName = response.data.name
          this.setMeetingForm()
        }else{
          this.store.dispatch(new ProgramOfficeActions.ProgramOfficeInfo);
        }
      })
    }
    else if (this.profileData.accountType === ACCOUNT_TYPE.INDIVIDUAL) {

      this.store.pipe(select(getIndividualProfileInfo)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((response) => {
        if (response) {
          this.companyName = response.data.name
          this.setMeetingForm()
        }else{
          this.store.dispatch(new IndividualActions.GetIndividualProfileInfo);
        }
      })
    }
  }

  async calculateSlots(date, calculatingEndTime = false) {

    const uid = this.facility.uuid
    const month = ('' + date.month).length === 2 ? date.month : '0' + date.month
    const day = ('' + date.day).length === 2 ? date.day : '0' + date.day
    const selectedDateFormatted = `${date.year}-${month}-${day}`

    const dateAvailability = await this.facilitiesService.getAvailabilityByDate(uid, selectedDateFormatted).toPromise()
    console.log('dateAvailability', dateAvailability)
    this.bookedCapacity = dateAvailability;
    this.isAvailableSeats = this.bookedCapacity?.availableCapacity ;
    this.bookedCapacityChange.emit(this.bookedCapacity)
    if(this.calenderAvilablity.availabilityTimeType === 'day' && dateAvailability?.length) {
      this.facilityBookedForDay = true
    }else{
      this.facilityBookedForDay = false
    }
   if (date && this.facility) {
      this.getExistingBookedFacilitie(this.facility);
    }
    let newTimeSlots = await calculateSlots({
      date,
      brandDetails: this.brandDetails,
      calendar: this.calendar,
      calenderAvilablity: this.calenderAvilablity,
      dateAvailability,
      timeSlots: this.timeSlots,
      localtime: true,
      bufferTime: this.calenderAvilablity.availabilityTimeType === 'hour' ? this.calenderAvilablity.leapTime :0,
      calculatingEndTime
    })
    return newTimeSlots
  }


  onSubmit(): void {
    const payload: IMeetingPatchModel = {
      ...this.meetingForm.value,
      meetingTimeType: MeetingTime.schedule_later,
    }
    const {
  date,
  endDate,
  bookingPocName,
  bookingPocEmail,
  bookingPocContactNumber,
  bookingPoCOrgName,
  bookingPoCDesignation
} = this.meetingForm.getRawValue();

    payload.date = `${date.year}-${date.month}-${date.day}`

    const utcTimeFrom = moment(`${date.year}-${date.month}-${date.day} ${payload.timeFrom}`, 'YYYY-MM-DD HH:mm')
    const sqlDateFrom = utcTimeFrom.format("YYYY-MM-DD")
    const sqlTimeFrom = utcTimeFrom.format("HH:mm")


    const endDateToConsider = this.calenderAvilablity.availabilityTimeType === 'hour' ? date : endDate;
    const utcTimeTo = moment(`${endDateToConsider.year}-${endDateToConsider.month}-${endDateToConsider.day} ${payload.timeTo}`, 'YYYY-MM-DD HH:mm')
    const sqlDateTo = utcTimeTo.format("YYYY-MM-DD")
    const sqlTimeTo = utcTimeTo.format("HH:mm")

    console.log('sqlDateFrom', sqlDateFrom, 'sqlTimeFrom', sqlTimeFrom);
    console.log('sqlDateFrom', sqlDateTo, 'sqlTimeFrom', sqlTimeTo, utcTimeTo);


    let payloadNew: any = {
      bookingPocName, bookingPocEmail,
      bookingPocContactNumber, bookingPoCOrgName, bookingPoCDesignation,
      bookingCapacity:this.meetingForm.value.numberOfSeats,
      duration: this.meetingForm.value.numberOfDays,
      bookingUserId: this.profileData?.id|| null,
      bookingTimeType:this.meetingForm.get('bookingDuration')?.value,
      sessionToken: localStorage.getItem('booking_session_token')

    }
    if (this.calenderAvilablity.availabilityTimeType === 'hour') {
      payloadNew = {
        ...payloadNew,
        "startDate": sqlDateFrom,
        "startTime": sqlTimeFrom,
        "endDate": sqlDateTo,
        "endTime": sqlTimeTo,
        "comments": this.meetingForm.value.meetingDescription,
      }
    } else {
      payloadNew = {
        ...payloadNew,
        "startDate": sqlDateFrom,
        "startTime": "00:00",
        "endDate": sqlDateTo,
        "endTime": "23:59",
        "comments": this.meetingForm.value.meetingDescription,
      }
    }
    this.ngxLoaderService.startLoader('book-facilitys-loader');
    this.facilitiesService.bookFacility_NewVersion(this.facility.uuid,payloadNew).subscribe((response) => {
       this.ngxLoaderService.stopLoader('book-facilitys-loader');
      if (response) {
        this.openCheckoutPage(response.data?.booking?.id);
        if (this.facility.isPaymentRequired) {
          this.toastAlertService.showToast('Booking request submitted. Please complete the payment within 10 minutes to confirm your booking.'
          );
        } else if ( !this.facility.isPaymentRequired && response.data.bookingStatus === 'pending') {
          this.toastAlertService.showToast("Booking status: Pending. Awaiting confirmation from the administrator.");
        }
      }
    }, err => {
      this.ngxLoaderService.stopLoader('book-facilitys-loader');
    })
  }

  
get bookingCapacity(): number {
  const available = this.isAvailableSeats ?? 0;
  const selected = this.meetingForm.value.numberOfSeats ?? 0;
  return Math.max(0, available - selected);
}

get noSeatsAvailable(): boolean {
  return (this.isAvailableSeats ?? 0) <= 0;
}

setDuration(type: string) {
  const prices = {
    hour: this.facility.modulePricing?.hourlyPricing ?? 0,
    day: this.facility.modulePricing?.dailyPricing ?? 0,
    week: this.facility.modulePricing?.weeklyPricing ?? 0,
    month: this.facility.modulePricing?.monthlyPricing ?? 0,
    year: this.facility.modulePricing?.yearlyPricing ?? 0,
  };
  
  this.meetingForm.patchValue({
    bookingDuration: type,
    basePrice: prices[type] ?? 0
  });
   if (type !== 'hour') {
    this.updateEndDateForPaymentRequired(type);
  }
  this.calculateTotal();
}
private getMomentUnit(type: string): moment.unitOfTime.DurationConstructor | null {
  const map = {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year'
  } as const;

  return map[type] ?? null;
}


private updateEndDateForPaymentRequired(durationType?: string): void {
  const startDate = this.meetingForm.get('date')?.value;
  const duration = this.meetingForm.get('numberOfDays')?.value;

  if (!startDate || !duration) return;

  const bookingDuration =
    durationType ?? this.meetingForm.get('bookingDuration')?.value;

  const unit = this.getMomentUnit(bookingDuration);
  if (!unit) return;

  const start = moment(
    `${startDate.year}-${startDate.month}-${startDate.day}`,
    'YYYY-MM-DD'
  );

  // const end =
  //   unit === 'day'
  //     ? start.clone().add(duration - 1, 'day')
  //     : start.clone().add(duration, unit);

    let end: moment.Moment;

  if (unit === 'day') {
    end = start.clone().add(duration - 1, 'day');
  } 
  else if (unit === 'month') {
    end = start.clone().add(duration, 'month').subtract(1, 'day');
  } 
  else {
    // week / year
    end = start.clone().add(duration, unit);
  }

  const endDateStruct: NgbDateStruct = {
    year: end.year(),
    month: end.month() + 1,
    day: end.date()
  };

  this.meetingForm.patchValue(
    { endDate: endDateStruct },
    { emitEvent: false }
  );

  this.endDateModel = endDateStruct;

  this.checkFacilityBookedForDay(startDate, endDateStruct);
}


  openCheckoutPage(bookingId): void {
    const { name, address ,id} = this.facility;
    this.modalHandler.openCheckoutModal({
      moduleType: 'facilities',
      selectedCycle: null,
      selectedPrice: this.meetingForm.get('totalPrice')?.value,
      additionalData: {
        name,
        bookingId:bookingId,
        // address,
        duration: this.meetingForm.value.numberOfDays,
        bookingCapacity:this.meetingForm.value.numberOfSeats,
        moduleTypeId: id,
        ...(this.facility?.modulePricing && {
          chargesTypes: this.facility.modulePricing.chargesTypes,
          charges: this.facility.modulePricing.charges,
          taxProfile: this.facility.modulePricing.taxProfile,
          isChargesIncluded: this.facility.modulePricing.isChargesIncluded,
          isTaxIncluded: this.facility.modulePricing.isTaxIncluded,
          isCouponsIncluded: this.facility.modulePricing.isCouponsIncluded,
        }),
          applicantId: this.profileData?.id || null,
          activeProgramUrl:  this.profileData ? 'facilities-management/my-bookings' : 'facilities-management',
        paymentType: 'facility',
      }
    }).then(async (result) => {
      console.log('Payment result:', result);
        if (result?.status === 'closed') { 
        const values = this.meetingForm.value
       await this.calculateSlots(values.date)
        }
    }).catch(() => { });
  }

  close() {
    this.modal.dismissAll();
  }

  onTimeToChange($event) {
    console.log(';event', $event)
  }


changeDays(val: number) {
  const days = Math.max(1, this.meetingForm.value.numberOfDays + val);
  this.meetingForm.patchValue({ numberOfDays: days });
  this.calculateTotal();
}

changeSeats(val: number) {
  const currentSeats = this.meetingForm.value.numberOfSeats;
  const maxSeats = this.isAvailableSeats ?? 1;

  const seats = Math.min(
    maxSeats,
    Math.max(1, currentSeats + val)
  );

  this.meetingForm.patchValue({ numberOfSeats: seats });
  this.calculateTotal();
}


calculateTotal() {
  const { basePrice, numberOfDays, numberOfSeats } = this.meetingForm.value;

  // whitout addons total
  const subtotal = basePrice * numberOfDays * numberOfSeats;

  // addons total (frontend quantity only)
  const addonsTotal = this.facility.facilityAddons
    .filter(addon => addon.selectedQuantity > 0)
    .reduce(
      (sum, addon) => sum + addon.pricePerUnit * addon.selectedQuantity,
      0
    );
  const total = subtotal + addonsTotal;

  this.meetingForm.patchValue(
    { totalPrice: total },
    { emitEvent: false }
  );
}

isFacilityBookedForSelectedSlot(): boolean {

  // If seats available → never show booked message
  if ((this.isAvailableSeats ?? 0) > 0) {
    return false;
  }

  return (
    this.facilityBookedForDay ||
    this.facilityBookedForDayCalculatedOnFrontend ||
    this.facilityBookedForHour
  );
}


  ngOnDestroy() {
    this.stopHoldCountdown();
    this.destroyed$.next();
    this.destroyed$.complete();
  }


}
